import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { AppRoutes, buildRoute } from '@/route/routeConfig';
import SignIn from '../../pages/Auth/SignIn';
import { authSelector } from '../../store';
import ForgotPassword from './ForgotPassword';
import PasswordResetRequested from './PasswordResetRequested';

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, data } = useSelector(authSelector);

  useEffect(() => {
    if (isLoggedIn) {
      // Redirect to onboarding if user has an onboarding profile
      console.log('onboarding profile', data?.onboardingProfile);
      if (data?.onboardingProfile?.onboardingType === 'single-project' && data?.onboardingProfile?.isComplete === false) {
        navigate(buildRoute(AppRoutes.SME_ONBOARDING_SINGLE_REGISTER), { replace: true });
        return;
      }

      let redirectPath = data.isSuper ? '/os/clients' : '/terminal/dashboard';

      if (location.state !== null) {
        redirectPath = location.state.from.pathname;
      }
      navigate(redirectPath, { replace: true });
    }
  }, [isLoggedIn, data.onboardingProfile, location.state, navigate]);

  function nextSlide(id: string) {
    const activeSlide = document.getElementById(id);
    activeSlide?.classList.remove('translate-x-0');
    activeSlide?.classList.add('-translate-x-full');
    if (id === 'signIn') {
      const nextSlide = document.getElementById('forgotPassword');
      nextSlide?.classList.remove('translate-x-full');
      nextSlide?.classList.add('translate-x-0');
    } else if (id === 'forgotPassword') {
      const nextSlide = document.getElementById('passwordResetRequested');
      nextSlide?.classList.remove('translate-x-full');
      nextSlide?.classList.add('translate-x-0');
    } else if (id === 'passwordResetRequested') {
      const nextSlide = document.getElementById('signIn');
      nextSlide?.classList.remove('-translate-x-full');
      nextSlide?.classList.add('translate-x-0');

      const allSlide = document.getElementsByClassName('slide');
      for (let i = 0; i < allSlide.length; i++) {
        allSlide[i].classList.remove('-translate-x-full');
        allSlide[i].classList.add('translate-x-full');
      }
    } else {
      const nextSlide = activeSlide?.nextElementSibling;
      nextSlide?.classList.remove('translate-x-full');
      nextSlide?.classList.add('translate-x-0');
    }
  }

  function previousSlide(id: string) {
    const activeSlide = document.getElementById(id);
    activeSlide?.classList.remove('translate-x-0');
    activeSlide?.classList.add('translate-x-full');

    const previousSlide = activeSlide?.previousElementSibling;
    previousSlide?.classList.remove('-translate-x-full');
    previousSlide?.classList.add('translate-x-0');
  }

  const renderContent = () => {
    return (
      <div className='w-full h-full bg-white'>
        <div className='h-full  overflow-y-auto overflow-x-clip'>
          <div className='h-full w-full relative'>
            <div
              id='signIn'
              className='absolute inset-0 top-[10%] flex items-start justify-center transition-all ease-in-out duration-1000 transform translate-x-0'
            >
              <SignIn slideHandler={() => nextSlide('signIn')} />
            </div>
            <div
              id='forgotPassword'
              className='absolute inset-0 top-[10%] flex items-start justify-center transition-all ease-in-out duration-1000 transform  translate-x-full slide'
            >
              <ForgotPassword backHandler={() => previousSlide('forgotPassword')} forwardHandler={() => nextSlide('forgotPassword')} />
            </div>
            <div
              id='passwordResetRequested'
              className='absolute inset-0 top-[10%] flex items-start justify-center transition-all ease-in-out duration-1000 transform  translate-x-full slide'
            >
              <PasswordResetRequested forwardHandler={() => nextSlide('passwordResetRequested')} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <div className='display flex flex-col justify-between h-screen'>{renderContent()}</div>;
};

export default Home;
